import { Input, RadioGroup } from '@platform/components';
import { Dispatch, SetStateAction } from 'react';
import { DeclineReasons } from '.';

interface RepDecliningIntroductionModalContent {
  additionalDetails: string;
  setAdditionalDetails: Dispatch<SetStateAction<string>>;
  declineReason: DeclineReasons | undefined;
  setDeclineReason: Dispatch<SetStateAction<DeclineReasons | undefined>>;
}

const RepDecliningIntroductionModalContent = (props: RepDecliningIntroductionModalContent) => {
  const { additionalDetails, setAdditionalDetails, setDeclineReason, declineReason } = { ...props };

  const detailsError =
    declineReason === DeclineReasons.Other && !additionalDetails ?
      "To continue, tell us more about why you're declining"
    : undefined;

  const validateRadio = (value: string | number | null): string | undefined => {
    if (!value) {
      return "To continue, select the reason you're declining";
    }
  };

  return (
    <div className='flex flex-col gap-2'>
      <div className='text-center'>Can you tell us why you're declining this introduction?</div>
      <div className='text-center'>Don't worry, this won't be shared with the Experteer.</div>
      <div className='mt-4'>
        <RadioGroup
          name='decline-reason'
          aria-label='decline-reason'
          validate={validateRadio}
          items={[
            {
              value: DeclineReasons.Different_Choice,
              title: "I'm choosing a different Experteer",
            },
            {
              value: DeclineReasons.Wrong_Skills,
              title: "Experteer doesn't have the right skills",
            },
            {
              value: DeclineReasons.Project_Done,
              title: 'I no longer need this project',
            },
            {
              value: DeclineReasons.Other,
              title: 'Other',
            },
          ]}
          onChange={(value) => {
            setDeclineReason(value as DeclineReasons);
          }}
        />
      </div>
      <div className='mt-4'>
        <div className='text-sm'>Additional Details</div>
        <Input
          type='multiline'
          required={declineReason === DeclineReasons.Other}
          placeholder="Tell us more about why you're declining..."
          error={detailsError}
          onChange={(e) => {
            setAdditionalDetails(e.target.value);
          }}
          value={additionalDetails}
        />
      </div>
    </div>
  );
};

export default RepDecliningIntroductionModalContent;
